import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, CalendarCheck } from 'lucide-react';
import clsx from 'clsx';
import styles from './QuickActions.module.css';

const SchedulerQuickActions: React.FC = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'View Contracts Ready for Scheduling',
      icon: Calendar,
      action: () => { navigate('/scheduler?state=ready_for_scheduling'); },
      variant: 'primary' as const,
      description: 'Review and schedule assessment meetings'
    },
    {
      label: 'View In Scheduling Meetings',
      icon: CalendarCheck,
      action: () => { navigate('/scheduler?state=scheduled'); },
      variant: 'secondary' as const,
      description: 'Check upcoming in scheduling meetings'
    }
  ];

  return (
    <div className={styles.quickActionsContainer}>
      <div className={styles.actionsHeader}>
        <h3>Quick Actions</h3>
        <p>Common tasks for Schedulers</p>
      </div>

      <div className={styles.actionsGrid}>
        {actions.map((action) => {
          const IconComponent = action.icon;
          return (
            <button
              type="button"
              key={`action-${action.label}`}
              className={clsx(
                styles.actionCard,
                action.variant === 'primary' && styles.actionCardPrimary,
                action.variant === 'secondary' && styles.actionCardSecondary
              )}
              onClick={action.action}
            >
              <div className={styles.actionContent}>
                <div className={styles.actionIcon}>
                  <IconComponent size={20} />
                </div>
                <div className={styles.actionDetails}>
                  <div className={styles.actionLabel}>{action.label}</div>
                  <div className={styles.actionDescription}>{action.description}</div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SchedulerQuickActions;
